import React from "react";
import { InventoryReceivingReport } from "./InventoryReceivingReport";

export default function InventoryReceiving() {
  return (
    <InventoryReceivingReport
      title="Inventory Receiving"
      subtitle="Review received inventory orders and line-item details."
      endpoint="/inventory/orders"
      exportFileName="InventoryReceiving"
      worksheetName="Inventory Receiving"
    />
  );
}
